import { render } from "./AdditionalApp.vue?vue&type=template&id=770539d2&scoped=true"
import script from "./AdditionalApp.vue?vue&type=script&lang=js"
export * from "./AdditionalApp.vue?vue&type=script&lang=js"

import "./AdditionalApp.vue?vue&type=style&index=0&id=770539d2&lang=css"
import "./AdditionalApp.vue?vue&type=style&index=1&id=770539d2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-770539d2"]])

export default __exports__